import { Box, Typography } from "@mui/material";
import { colors } from "@components/ui/colors";
import { FLOW_OPTIONS } from "./ConfigureCallFlows";
import CheckRoundedIcon from '@mui/icons-material/CheckRounded';

interface Props {
    option: (typeof FLOW_OPTIONS)[number];
    selected: boolean;
    onSelect: () => void;
    disabled: boolean;
}

export const FlowCard = ({ option, selected, onSelect, disabled }: Props) => (
    <Box
        onClick={!disabled ? onSelect : undefined}
        sx={{
            border: selected ? `2px solid ${colors.orange.base}` : "1.5px solid var(--fx-surface-border, #E2E8F0)",
            borderRadius: 3,
            p: 1.75,
            position: "relative",
            transition: "all 0.15s",
            cursor: disabled ? "not-allowed" : "pointer",
            pointerEvents: disabled ? "none" : "auto",
            opacity: disabled ? 0.5 : 1,
            filter: disabled ? "grayscale(0.8)" : "none",
            "&:hover": {
                borderColor: !disabled && (selected ? colors.orange.base : "#D1D5DB"),
                boxShadow: !disabled ? "0 2px 8px rgba(0,0,0,0.06)" : "none",
            },
        }}
    >
        {selected && (
            <Box
                sx={{
                    position: "absolute",
                    top: 8,
                    right: 8,
                    width: 20,
                    height: 20,
                    borderRadius: "50%",
                    bgcolor: colors.orange.base,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    zIndex: 1,
                }}
            >
                <CheckRoundedIcon sx={{ fontSize: 12, color: "white" }} />
            </Box>
        )}

        <Box
            sx={{
                width: 38,
                height: 38,
                borderRadius: "50%",
                bgcolor: selected ? "var(--fx-colors-warning-50, #FFF7ED)" : "var(--fx-surface-muted, #F1F5F9)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                color: selected ? colors.orange.base : "#6B7280",
                mb: 1.25,
                transition: "background 0.15s, color 0.15s",
            }}
        >
            {option.icon}
        </Box>

        <Typography sx={{ fontSize: 13, fontWeight: 700, color: "var(--fx-surface-text, #0F172A)", mb: 0.5 }}>
            {option.label}
        </Typography>

        <Typography sx={{ fontSize: 11, color: "var(--fx-surface-textsecondary, #64748B)", lineHeight: 1.5, mb: 1.25 }}>
            {option.description}
        </Typography>

        <Typography
            sx={{
                fontSize: 10,
                fontWeight: 700,
                color: colors.orange.base,
                textTransform: "uppercase",
                letterSpacing: "0.04em",
                mb: 0.25,
            }}
        >
            Best for
        </Typography>
        <Typography sx={{ fontSize: 11, color: "var(--fx-surface-textsecondary, #64748B)", lineHeight: 1.4 }}>
            {option.bestFor}
        </Typography>
    </Box>
);